import {Confirm} from "../../../confirm/confirm";
import {Notification} from "../../../notification/notfication";
import Axios, {AxiosResponse} from "axios";
import {ICreateBackupResponse} from "../../interface";
import { Dialog } from "../../../dialog/dialog";
import { Gamecloud } from "../../gamecloud";
import i18next from 'i18next';

export class Backup extends Gamecloud {
    private _state;

    readonly backupDelayReloadPage                  : number = 500;
    readonly serverWidgetIdentifier                 : string = '.serverWidget';
    readonly deleteBackupButtonIdentifier           : string = '.delete_backup';
    readonly restoreBackupButtonIdentifier          : string = '.restore_backup';
    readonly createBackupButtonIdentifier           : string = '#make_backup';
    readonly deamonStateMaintenance                 : string = 'maintenance';

    /**
     *
     * @param {number} serverId
     */
    public constructor(private serverId : number) {
        super();
        this._bindCallbacks();
        this._bindWebSocket();
    }

    /**
     * used to force a reload of the page after the delay
     * @param {number} delay
     */
    private reloadPage(delay : number) : void {
        setTimeout(function(){
            window.location.reload(true);
        }, delay)
    }

    private _bindWebSocket() : void {
        window.addEventListener('socketData', (event: CustomEvent) => {
            if(event.detail.id == this.serverId && this._state == this.deamonStateMaintenance) {
                this.reloadPage(this.backupDelayReloadPage);
            }

            this._state = event.detail.data.type;
        });

        /*
        $(this.serverWidgetIdentifier).bind('servicestatechanged', (event, data) => {
            console.log(event);

            if(this._state == 'maintenance') {
                this.reloadPage(this.backupDelayReloadPage);
            }

            this._state = data.stateName;
        });
        */
    }


    /**
     * is used for binding our callbacks to button click actions
     * @private
     */
    private _bindCallbacks() {
        $(this.createBackupButtonIdentifier).click((event : JQuery.TriggeredEvent) => { this.createBackup(event) });
        $(this.deleteBackupButtonIdentifier).click((event : JQuery.TriggeredEvent) => { this.deleteBackup(event) });
        $(this.restoreBackupButtonIdentifier).click((event : JQuery.TriggeredEvent) => { this.restoreBackup(event) });
    }

    /**
     * used to create a Backup
     */
    public createBackup(event : JQuery.TriggeredEvent) : void {
        new Dialog()
          .withTitle('Are you sure?')
          .withText('Do you really want to create a new backup?')
          .withCenteredContent()
          .withIcon('cloud-upload-alt')
          .withConfirmButtonText('Confirm')
          .withOnConfirm(() => {
            this.loader.enable()
            let url = window.createBackupUrl;
            let form: FormData = this._getFormData(event);

            Axios.post(url, form, {
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'json'
              }
            }).then((response: AxiosResponse<ICreateBackupResponse>) => {
              this.loader.disable()
              if (response.data.result) {
                new Notification('success', 'Done', i18next.t('general:notification.backup.creation'));
                this.reloadPage(2000);
              }
              else {
                new Notification('danger', 'Error', response.data.message);
              }
            }, () => {
              new Notification('danger', 'Error', 'Backup could not be created due to an error!');
            });
          })
          .render();
    }

    /**
     *
     * @param {JQuery.TriggeredEvent} event
     * @returns {string}
     * @private
     */
    private static getBackupIdFromEvent(event : JQuery.TriggeredEvent) : string {
        console.log($(event.target).attr('data-backupid'));
        return $(event.target).attr('data-backupid');
    }

    /**
     * used to delete a backup with a specific revisionId
     * @param {JQuery.TriggeredEvent} event
     */
    public deleteBackup(event : JQuery.TriggeredEvent) : void {
      new Dialog()
        .withIcon('trash-alt')
        .withText('Do you really want to delete this backup?')
        .withOnConfirm(() => {
          let url = window.deleteBackupUrl;
          let form: FormData = this._getFormData(event);

          Axios.post(url, form, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }).then((response: AxiosResponse) => {
            if (response.data) {
              new Notification('success', 'Done', 'Backup deleted!');
              this.reloadPage(2000);
            }
            else
              new Notification('danger', 'Error', 'Backup could not be deleted due to an error!');

          }, () => {
            new Notification('danger', 'Error', 'Backup could not be deleted due to an error!');
          });
        })
        .withTitle('Are you sure?')
        .withCenteredContent()
        .render();
    }

    /**
     *
     * @param {JQuery.TriggeredEvent} event
     * @returns {FormData}
     * @private
     */
    private _getFormData(event : JQuery.TriggeredEvent) : FormData {
        let form = new FormData();
        form.append('serverId',         this.serverId.toString());
        form.append('backupId',            Backup.getBackupIdFromEvent(event));

        return form;
    }

    /**
     * used to restore a backup with a specific revisionId
     * @param {JQuery.TriggeredEvent} event
     */
    public restoreBackup(event : JQuery.TriggeredEvent) : void {
        new Dialog()
          .withCenteredContent()
          .withCancelButtonText('Cancel')
          .withConfirmButtonText('Confirm')
          .withOnConfirm(() => {
            let url = window.restoreBackupUrl;
            let form: FormData = this._getFormData(event);
            Axios.post(url, form, {
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'json'
              }
            }).then((response: AxiosResponse) => {
              new Notification('success', 'Done', 'Backup restored!');
            }, () => {
              new Notification('danger', 'Error', 'Backup could not be restored due to an error!');
            });
          })
          .withText('Do you really want to restore this backup?')
          .withTitle('Are you sure?')
          .withIcon('cloud-upload-alt')
          .render();
    }
}

export function initBackup() {
    let backupAppSelector : string = '#backup-application';

    if($(backupAppSelector).length) {
        if(window.gameserverId != null && window.gameserverId !== undefined) {
            new Backup(window.gameserverId);
        }
    }
    /* @TODO: implement stuff */
}
